<a (click)="paketdetailsSpeichern()" *ngIf="speichernBtAnzeigen"
   [disabled]="paketSpeichernDisabled"
   [ngClass]="paketSpeichernDisabled ? 'mini-button-disabled' : 'mini-button'"
   mat-button>Speichern</a>

<a (click)="paketdeailsPruefen()" *ngIf="pruefenBtAnzeigen"
   [disabled]="paketPruefenDisabled"
   [ngClass]="paketPruefenDisabled ? 'mini-button-disabled' : 'mini-button'"
   mat-button>Prüfen</a>

<a (click)="einspielenTeilpaket()"  *ngIf="einspielenBtAnzeigen"
   [disabled]="!einspielenBtAktiv"
   [ngClass]="einspielenBtAktiv ? 'mini-button' : 'mini-button-disabled'"
   mat-button>Teilpaket einspielen</a>

<a (click)="paketdeailsAbbruch()"
   class="mini-button"
   mat-button>Zurück</a>

<a *ngIf="exportEnabled" (click)="exportCSV(cols, values, teilpaket.dateiname)"
   class="mini-button"
   mat-button>Export</a>


  <p class="label-text_light_blue">Ausgewähltes Paket: <b>{{teilpaket.beschreibung}}</b> (Status: <b>{{teilpaket.status}})</b></p>
<progress-bar *ngIf="isLoadToBiproProcess" [progress]="loadBarTimer" [color-degraded]="{'1': '#f9c3d3', '50': '#00cbcb', '75': '488aff'}">
</progress-bar>

<div class="table-container">
  <p-table #dt [scrollable]="true" scrollHeight="400px"
           [responsive]="true"
           [resizableColumns]="true"
           [paginator]="true" [rows]="5"
           [rowsPerPageOptions]="[5,10,15]"
           [(selection)]="selectedRow"
           [columns]="cols"
           [value]="values"
           (sortFunction)="customSort($event)"
           [customSort]="true"
           sortField="Name VN" [sortOrder]="-1"
           >
    <ng-template let-columns pTemplate="colgroup">
      <colgroup>
        <col style="width: 3em;">
        <col *ngFor="let col of columns" [style.width]="(longestValueOfCol(col.header) * 6 + 95) + 'px'" >
      </colgroup>
    </ng-template>
    <ng-template let-columns pTemplate="header">
      <!-- erste Überschrifts-Zeile -->
      <tr>
        <th *ngIf="selectable" pResizableColumn></th>
        <th *ngFor="let col of columns; trackBy: trackVorgangTable"
            [pSortableColumn]="col.field"
            pResizableColumn>
          {{col.header | umlautPipe}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelAsc="Activate to sort in ascending order"
                      ariaLabelDesc="Activate to sort in descending order"></p-sortIcon>
        </th>
      </tr>
      <!-- zweite Überschrifts-Zeile (Filter) -->
      <tr>
        <th *ngIf="selectable"></th>
        <th *ngFor="let col of columns; trackBy: trackVorgangTable"
            pResizableColumn
            [ngSwitch]="col.field">
          <!--p-dropdown appendTo="body" *ngSwitchCase="'Status'"
                         [options]="statusAllList" defaultLabel="alle Status"
                         (onChange)="dt.filter($event.value, 'Status.string', 'equals')"></p-dropdown-->
          <p-multiSelect appendTo="body" [style]="{'font-size': '11px'}"
                         *ngSwitchCase="'Status'"
                         [options]="statusAllList" defaultLabel="Alle Status"
                         (onChange)="dt.filter($event.value, 'Status.string', 'in')"></p-multiSelect>
          <!-- Filter-Felder -->
          <input *ngIf="isFilterFeld(col.field) && (col.field != 'Status') && !isAuswahlFeld(col.field)"
                 pInputText type="text" style="width: 100%"
                 (input)="dt.filter($event.target.value, col.field + (col.field == 'HINWEIS' ? '.errorMeldung' : '.string'), 'contains')">
          <p-multiSelect *ngIf="isFilterFeld(col.field) && (col.field != 'Status') && isAuswahlFeld(col.field)"
                         appendTo="body"
                         [style]="{'font-size': '11px','width':'100%','height':'24px'}"
                         [options]="filterFields[col.field]" defaultLabel=""
                         (onChange)="dt.filter($event.value, col.field + '.string', 'in')">
          </p-multiSelect>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">Keine Daten zur Anzeige gefunden</td>
      </tr>
    </ng-template>

    <div *ngIf="tableEditable">
      <ng-template let-columns="cols" let-value pTemplate="body" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="value">
          <td *ngIf="selectable">
            <mat-icon [style.color]="getColorOfIcon(value['Status'].string)">fiber_manual_record</mat-icon>
          </td>
          <!-- editierbare Zeile -->
          <td [hidden]="value['Status'].string==VorgangStatus.EINGESPIELT" *ngFor="let col of cols; let colIndex=index" pEditableColumn id="{{rowIndex}}-{{colIndex}}">
            <!-- Status-Spalte - "colIndex==0" -->
            <p-cellEditor *ngIf="colIndex==0">
              <ng-template  pTemplate="input">
                <select #selectElem
                        [style]="{'font-size': '11px;'}"
                        [(ngModel)]="value['Status'].string"
                        (ngModelChange)="changeStatusDone(rowIndex, colIndex)" [disabled]="!isCellStatusEditable(rowIndex)">
                  <option *ngFor="let status of getStatusChangeList(value['Status'].string)" [value]="status.value">
                    {{status.value}}
                  </option>
                </select>
                <!-- bei p-dropdown muss man bei dieser Variante den Eintrag in der Auswahlliste doppelklicken -->
                <!--p-dropdown appendTo="body"
                          [options] = "getStatusChangeList(value['Status'].string)"
                          [(ngModel)]="value['Status'].string"
                          [style]="{'font-size': '11px'}"
                          (ngModelChange)="changeStatusDone(rowIndex, colIndex)"></p-dropdown-->
              </ng-template>
              <ng-template pTemplate="output">
                {{value['Status'].string}}
              </ng-template>
            </p-cellEditor>

            <!-- alle anderen Spalten ausser Status-Spalte - colIndex != 0 -->
            <p-cellEditor *ngIf="!checkNotMultipleFieldsIndexes(colIndex)&&colIndex!=0">
              <ng-template  pTemplate="input">
                <select #selectElem
                        [style]="{'font-size': '11px;'}"
                        [(ngModel)]="value[getFiledDependsOnIndex(colIndex)].string"
                        (change)="changeDone(rowIndex, colIndex, value[col.header], value)">
                  <option *ngFor="let generalizedValue of getGeneralizedChangeList(colIndex)" [value]="generalizedValue.value">
                    {{generalizedValue.value}}
                  </option>
                </select>
              </ng-template>
              <!-- Select-Boxen / List-Boxen / Auswahlfelder / what ever... -->
              <ng-template pTemplate="output">
                <span [ngStyle]="{'color':(value[col.header].errorMeldung && value[col.header].errorMeldung.length > 0) ? 'red' : 'black'}">
                  {{(value[col.header].errorMeldung && value[col.header].errorMeldung.length > 0)
                      ? value[col.header].errorMeldung : value[getFiledDependsOnIndex(colIndex)].string}}</span>
              </ng-template>
            </p-cellEditor>

            <!-- manche Spalten sind editierbar -->
            <p-cellEditor *ngIf="checkNotMultipleFieldsIndexes(colIndex)&& tableColumnEditable(col.header)">
              <ng-template [ngIf]="!(colIndex==1)" pTemplate="input">
                <input [(ngModel)]="value[col.header].string" type="text" style="width: 89%; margin-left:9px"
                       (ngModelChange)="changeDone(rowIndex, colIndex, value[col.header], value)"
                       maxlength="50">
              </ng-template>
              <ng-template pTemplate="output">
                <span [ngStyle]="{'color':(value[col.header].errorMeldung!=null && value[col.header].errorMeldung!='') ? 'red' : 'black'}">
                  {{(value[col.header].errorMeldung!=null && value[col.header].errorMeldung!='')?value[col.header].errorMeldung:
                   isThisNum(value[col.header].string, col.header) ? (value[col.header].string | number:'1.2-2') : dateReplacer(value[col.header].string)}}</span>
              </ng-template>
            </p-cellEditor>
            <!-- manche Spalten sind NICHT editierbar -->
            <ng-template [ngIf]="!tableColumnEditable(col.header)" pTemplate="output">
              <span [ngStyle]="{'color':(value[col.header].errorMeldung!=null && value[col.header].errorMeldung!='') ? 'red' : 'black'}">
                {{(value[col.header].errorMeldung!=null && value[col.header].errorMeldung!='')?value[col.header].errorMeldung:
                isThisNum(value[col.header].string, col.header) ? (value[col.header].string | number:'1.2-2') : dateReplacer(value[col.header].string)}} </span>
            </ng-template>
          </td>
          <!-- nicht editierbare Zeile innerhalb eines Teilpakets bei eingespielten Vorgängen -->
          <td [hidden]="value['Status'].string!=VorgangStatus.EINGESPIELT" *ngFor="let col of cols">
              <span [ngStyle]="{'color':(value[col.header].errorMeldung!=null && value[col.header].errorMeldung!='') ? 'red' : 'black'}">
                {{(value[col.header].errorMeldung!=null && value[col.header].errorMeldung!='')?value[col.header].errorMeldung:
                isThisNum(value[col.header].string, col.header) ? (value[col.header].string | number:'1.2-2') : dateReplacer(value[col.header].string)}} </span>
          </td>
        </tr>
      </ng-template>
      </div>

    <div *ngIf="!tableEditable">
      <ng-template let-columns="cols" let-value pTemplate="body" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="value">
          <td *ngIf="selectable">
            <mat-icon [style.color]="getColorOfIcon(value['Status'].string)">fiber_manual_record</mat-icon>
          </td>
          <td pEditableColumn [pEditableColumnDisabled]="!isCellStatusEditable(rowIndex)">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <select #selectElem
                        [style]="{'font-size': '11px;'}"
                        [(ngModel)]="value['Status'].string"
                        (ngModelChange)="changeStatusDone(rowIndex, 0)">
                  <option *ngFor="let status of getStatusChangeList(value['Status'].string)" [value]="status.value">
                    {{status.value}}
                  </option>
                </select>
              </ng-template>
              <ng-template pTemplate="output">
                {{value['Status'].string}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td *ngFor="let col of cols | slice:1">
              <span [ngStyle]="{'color':(value[col.header].errorMeldung!=null && value[col.header].errorMeldung!='') ? 'red' : 'black'}">
                {{(value[col.header].errorMeldung!=null && value[col.header].errorMeldung!='')?value[col.header].errorMeldung:
                isThisNum(value[col.header].string, col.header) ? (value[col.header].string | number:'1.2-2') : dateReplacer(value[col.header].string)}} </span>
          </td>
        </tr>
      </ng-template>
    </div>
  </p-table>

  <div>
    <p class="label-text"><b>{{teilpaket.cntTotal}}</b> Vorgänge, <b>{{teilpaket.cntNok}}</b> fehlerhafte Vorgänge</p>
  </div>
</div>



<p-dialog header="Hinweis" [(visible)]="displayDialog"
          [responsive]="true" showEffect="fade"
          >
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
    Paketdetails wurden geändert!
      <br><br>Möchten Sie die Änderungen speichern?
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" pButton (click)="paketdeailsSchliessen()" label="Nein"></button>
      <button type="button" pButton (click)="paketdetailsSpeichern()" label="Ja"></button>
    </div>
  </p-footer>
</p-dialog>
